export default __webpack_public_path__ + "static/media/rec2dsin.57759da7.jpg";